module.exports = __webpack_public_path__ + "img/gif_check.54871256.gif";